import compareDesc from "date-fns/compareDesc";
import isEqual from "date-fns/isEqual";
var operators = {
    "lt": function (left, right) { return left < right; },
    "lte": function (left, right) { return left <= right; },
    "gt": function (left, right) { return left > right; },
    "gte": function (left, right) { return left >= right; },
    "e": isEqual
};
export var doesOverlapSlot = function (needleFrom, needleTo, haystackFrom, haystackTo) {
    // IF start of slot and range is equal, return true
    if (operators.e(needleFrom, haystackFrom)) {
        return true;
    }
    // IF start of slot and range is equal, return true
    if (operators.e(needleTo, haystackTo)) {
        return true;
    }
    if (haystackFrom < needleFrom && haystackTo > needleFrom) {
        return true;
    }
    if (haystackFrom < needleTo && haystackTo > needleTo) {
        return true;
    }
    if (haystackFrom > needleFrom && haystackTo < needleTo) {
        return true;
    }
    return false;
};
export var doesIntersectSlot = function (needleFrom, needleTo, haystackFrom, haystackTo, isInclusive) {
    if (isInclusive === void 0) { isInclusive = false; }
    var needleFromMatchesHayStackTo;
    {
        var operator = isInclusive ? "lt" : "lte";
        needleFromMatchesHayStackTo = operators[operator](needleFrom, haystackTo);
    }
    var needleToMatchesHayStackFrom;
    {
        var operator = isInclusive ? "gt" : "gte";
        needleToMatchesHayStackFrom = operators[operator](needleTo, haystackFrom);
    }
    // IF start of slot and range is equal, return true
    if (operators.e(needleFrom, haystackFrom)) {
        return true;
    }
    // IF start of slot and range is equal, return true
    if (operators.e(needleTo, haystackTo)) {
        return true;
    }
    if (operators.lt(needleFrom, haystackFrom) && needleFromMatchesHayStackTo) {
        return false;
    }
    if (needleToMatchesHayStackFrom && operators.gt(needleTo, haystackTo)) {
        return false;
    }
    return true;
    // if(compareDesc(slot.from, from) < 1 && compareDesc(slot.from, to) )
    // const left = compareDesc(slot.from, from);
    // const right = compareDesc(to, slot.to);
    //
    // return left !== -1 && right !== -1;
    // const leftOverlap = slot.from >= from;
    // const rightOverlap = to >= slot.to;
    //
    // if (inclusive) return leftOverlap && rightOverlap
    // return leftOverlap || rightOverlap
    // return areIntervalsOverlapping({
    //     start: from,
    //     end: to
    // }, {
    //     start: slot.from,
    //     end: slot.to
    // }, options);
};
export var isIncludedIn = function (needleFrom, needleTo, haystackFrom, haystackTo) {
    if (needleFrom < haystackFrom) {
        return false;
    }
    if (needleFrom > haystackTo) {
        return false;
    }
    if (needleTo > haystackTo) {
        return false;
    }
    if (needleTo < haystackFrom) {
        return false;
    }
    return true;
};
export var doesMatchSlot = function (from, to, slot) {
    return compareDesc(from, slot.from) === 0 && compareDesc(to, slot.to) === 0;
};
